import type { CpeAutoRapport } from "@/types/cpe";
import type { CpeautorapportState } from "@/types/store";
import type { MutationTree } from "vuex";

// Mutations

export const LOAD_AUTOCPERAPPORTS_HISTORY = "LOAD_AUTOCPERAPPORTS_HISTORY";
export const LOAD_AUTOCPERAPPORTS_HISTORY_SUCCESS =
  "LOAD_AUTOCPERAPPORTS_HISTORY_SUCCESS";
export const LOAD_AUTOCPERAPPORTS_HISTORY_FAILURE =
  "LOAD_AUTOCPERAPPORTS_HISTORY_FAILURE";

export const LOAD_AUTOCPERAPPORTS = "LOAD_AUTOCPERAPPORTS";
export const LOAD_AUTOCPERAPPORTS_SUCCESS = "LOAD_AUTOCPERAPPORTS_SUCCESS";
export const LOAD_AUTOCPERAPPORTS_FAILURE = "LOAD_AUTOCPERAPPORTS_FAILURE";

export const LOAD_AUTOCPERAPPORT = "LOAD_AUTOCPERAPPORT";
export const LOAD_AUTOCPERAPPORT_SUCCESS = "LOAD_AUTOCPERAPPORT_SUCCESS";
export const LOAD_AUTOCPERAPPORT_FAILURE = "LOAD_AUTOCPERAPPORT_FAILURE";

export const ADD_AUTOCPERAPPORT = "ADD_AUTOCPERAPPORT";
export const ADD_AUTOCPERAPPORT_SUCCESS = "ADD_AUTOCPERAPPORT_SUCCESS";
export const ADD_AUTOCPERAPPORT_FAILURE = "ADD_AUTOCPERAPPORT_FAILURE";

export const UPDATE_AUTOCPERAPPORT = "UPDATE_AUTOCPERAPPORT";
export const UPDATE_AUTOCPERAPPORT_SUCCESS = "UPDATE_AUTOCPERAPPORT_SUCCESS";
export const UPDATE_AUTOCPERAPPORT_FAILURE = "UPDATE_AUTOCPERAPPORT_FAILURE";

export const DELETE_AUTOCPERAPPORT = "DELETE_AUTOCPERAPPORT";
export const DELETE_AUTOCPERAPPORT_SUCCESS = "DELETE_AUTOCPERAPPORT_SUCCESS";
export const DELETE_AUTOCPERAPPORT_FAILURE = "DELETE_AUTOCPERAPPORT_FAILURE";

export const mutations: MutationTree<CpeautorapportState> = {
  [LOAD_AUTOCPERAPPORTS](state: CpeautorapportState) {
    state.cpeautorapports = {
      ...state.cpeautorapports,
      loading: true,
      error: null,
    };
  },
  [LOAD_AUTOCPERAPPORTS_SUCCESS](state: CpeautorapportState, data: any) {
    state.cpeautorapports = {
      data: data.data,
      loading: false,
      error: null,
      count: data.total_count,
    };
  },
  [LOAD_AUTOCPERAPPORTS_FAILURE](state: CpeautorapportState, error: string) {
    state.cpeautorapports = { ...state.cpeautorapports, loading: false, error };
  },
  [ADD_AUTOCPERAPPORT](state: CpeautorapportState) {
    state.cpeautorapports = {
      ...state.cpeautorapports,
      loading: true,
      error: null,
    };
  },
  [ADD_AUTOCPERAPPORT_SUCCESS](
    state: CpeautorapportState,
    bexrapport: CpeAutoRapport,
  ) {
    state.cpeautorapports = {
      ...state.cpeautorapports,
      data: [...state.cpeautorapports.data, bexrapport],
      loading: false,
      error: null,
    };
  },
  [ADD_AUTOCPERAPPORT_FAILURE](state: CpeautorapportState, error: string) {
    state.cpeautorapports = { ...state.cpeautorapports, loading: false, error };
  },
  [UPDATE_AUTOCPERAPPORT](state: CpeautorapportState) {
    state.cpeautorapports = {
      ...state.cpeautorapports,
      loading: true,
      error: null,
    };
  },
  [UPDATE_AUTOCPERAPPORT_SUCCESS](state: CpeautorapportState, bexrapport: any) {
    state.cpeautorapports.loading = false;
    state.cpeautorapports.error = null;
    const index = state.cpeautorapports.data.findIndex(
      (item: any) => item.id === bexrapport.id,
    );
    if (index !== -1) state.cpeautorapports.data[index] = bexrapport;
  },
  [UPDATE_AUTOCPERAPPORT_FAILURE](state: CpeautorapportState, error: string) {
    state.cpeautorapports = { ...state.cpeautorapports, loading: false, error };
  },

  [LOAD_AUTOCPERAPPORT](state: CpeautorapportState) {
    state.cpeautorapport = {
      ...state.cpeautorapport,
      loading: true,
      error: null,
    };
  },
  [LOAD_AUTOCPERAPPORT_SUCCESS](
    state: CpeautorapportState,
    event: CpeAutoRapport,
  ) {
    state.cpeautorapport = {
      data: event,
      loading: false,
      error: null,
    };
  },
  [LOAD_AUTOCPERAPPORT_FAILURE](state: CpeautorapportState, error: string) {
    state.cpeautorapport = {
      ...state.cpeautorapport,
      loading: false,
      error: error,
    };
  },

  [DELETE_AUTOCPERAPPORT](state: CpeautorapportState) {
    state.cpeautorapports = {
      ...state.cpeautorapports,
      loading: true,
      error: null,
    };
  },
  [DELETE_AUTOCPERAPPORT_SUCCESS](state: CpeautorapportState, id: any) {
    state.cpeautorapports = {
      data: state.cpeautorapports.data.filter(
        (sc: CpeAutoRapport) => sc.scheduledReportId !== id,
      ),
      loading: false,
      error: null,
      count: state.cpeautorapports.count - 1,
    };
  },
  [DELETE_AUTOCPERAPPORT_FAILURE](state: CpeautorapportState, error: string) {
    state.cpeautorapports = {
      ...state.cpeautorapports,
      loading: false,
      error: error,
    };
  },
  [LOAD_AUTOCPERAPPORTS_HISTORY](state: CpeautorapportState) {
    state.cpeautorapportshistory = {
      ...state.cpeautorapportshistory,
      loading: true,
      error: null,
    };
  },
  [LOAD_AUTOCPERAPPORTS_HISTORY_SUCCESS](
    state: CpeautorapportState,
    data: any,
  ) {
    state.cpeautorapportshistory = {
      data: data.data,
      loading: false,
      error: null,
      count: data.total_count,
    };
  },
  [LOAD_AUTOCPERAPPORTS_HISTORY_FAILURE](
    state: CpeautorapportState,
    error: string,
  ) {
    state.cpeautorapportshistory = {
      ...state.cpeautorapportshistory,
      loading: false,
      error,
    };
  },
};
